import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// Import pages
import Login from '@/views/Login';
import Register from '@/views/Register';
import Main from '@/views/Main';
import About from '@/views/About';
import Error404 from '@/views/Error404'
import Management from '@/views/Management';
import Dashboard from '@/views/Dashboard';
import Assessment from '@/views/Assessment';
import Forgot from '@/views/Forgot';
import Reset from '@/views/Reset';

// Import middleware
import guest from '@/middleware/guest';
import manager from '@/middleware/manager';
import auth from '@/middleware/auth';
import middlewarePipeline from '@/router/middlewarePipeline';


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            // Main page
            path: '/',
            name: 'main',
            component: Main,
            meta: {
                middleware: [
                    guest
                ]
            }
        },
        {
            // About page
            path: '/about',
            name: 'about',
            component: About,
            meta: {
                middleware: [
                    guest
                ]
            }
        },
        {
            // Login page
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                middleware: [
                    guest
                ]
            }
        },
        {
            // Register page
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                middleware: [
                    guest
                ]
            }
        },
        { 
            // Restore password
            path: '/forgot', 
            name: 'forgot', 
            component: Forgot, 
            meta: { 
                middleware: [
                    guest
                ]
            } 
          },
           // Resend password
          { 
            path: '/reset/:token', 
            name: 'reset', 
            component: Reset, 
            meta: { 
                middleware: [
                    guest
                ]
            } 
          },
        {
            // Management page
            path: '/management',
            name: 'management',
            component: Management,
            meta: {
                middleware: [
                    auth,
                    // manager
                ]
            }
        },
        {
            path: '/management/paycode/create',
            name: 'management.paycode.create',
            component: Management,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            // Dashboard page
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            // Assessment start
            path: '/assessment',
            name: 'assessment.start',
            component: Assessment,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            // Assessment update
            path: '/assessment/update',
            name: 'assessment.update',
            component: Assessment,
            props: true,
            meta: {
                middleware: [
                    guest
                    // auth
                ]
            },
        },
        {
            path: '/assessment/create',
            name: 'assessment.create',
            component: Assessment,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/assessment/completed',
            name: 'assessment.completed',
            component: Assessment,
            props: true,
            meta: {
                middleware: [
                    guest
                ]
            }
        },
        {
            // Errror 404 page Not found
            path: '*',
            name: 'error404',
            component: Error404
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next();
    }
    const middleware = to.meta.middleware;

    const context = {
        to,
        from,
        next,
        store
    }
    return middleware[0]({
        ...context,
        nextMiddleware: middlewarePipeline(context, middleware, 1)
    });
});

export default router;